import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const GradeName = ({ gradeName, handleGrade, gradeList, gradeId }) => {
  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Grade Name</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={gradeId + "#" + gradeName}
          label="Grade Name"
          onChange={handleGrade}
        >
          {gradeList?.map((el) => (
            <MenuItem key={el?.gradeId} value={`${el.gradeId}#${el.gradeName}`}>
              {el.gradeName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default GradeName;
